import { Dashboard } from '@elementary/common-ui/pages';
import ReportEmptyStatePage from '@/app/components/ReportEmptyStatePage';
import useDashboard from './useDashboard';

const DashboardPage = () => {
  const dashboardData = useDashboard();

  return (
    <Dashboard
      {...dashboardData}
      renderEmptyStatePage={() => <ReportEmptyStatePage />}
    />
  );
};

export default DashboardPage;
